import CustomDomain from './CustomDomain';

export default CustomDomain;
